import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import React from "react";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import { Breadcrumb } from "../../../general/modules/commons/breadcrumb/breadcrumb";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { useAuthorization } from "../../../../hooks/useAuthorization";
import { RequestQuickAddForm } from "../features/RequestQuickAddForm";

export const RequestQuickAddPage = () => {
  const { hasRole } = useAuthorization();

  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const title = t("Add request");
  if (
    hasRole("dbh-employee") ||
    hasRole("dbh-driver") ||
    hasRole("dbh-order-picker")
  ) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb />
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader className={"mb-3"} title={title} />

          <RequestQuickAddForm />
        </Content>
      </LayoutContent>
    </Layout>
  );
};
